import React from 'react';
import { MemoryRouter as Router, Route, Routes } from 'react-router-dom';
import Home from './pages/Home/Home';
import Global from './Global';

export default function App() {
  return (
    <Router>
      <Routes>
        <Route path="" element={<Global />} />
      </Routes>
    </Router>
  );
}
